<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Inspiration 2xfotoHeading:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'Inspiration1Image')"
            [blockData]="block.variables?.Inspiration1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="Inspiration1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration2Image')"
            [blockData]="block.variables?.Inspiration2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="Inspiration2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration1ImageHref')"
            [blockData]="block.variables?.Inspiration1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="Inspiration1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.Inspiration1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration2ImageHref')"
            [blockData]="block.variables?.Inspiration2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="Inspiration2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.Inspiration2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'Inspiration1ImageAlt')"
            [blockData]="block.variables?.Inspiration1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="Inspiration1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration2ImageAlt')"
            [blockData]="block.variables?.Inspiration2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="Inspiration2ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'Inspiration1Heading')"
            [blockData]="block.variables?.Inspiration1Heading ?? ''"
            [placeholder]="heading1Placeholder"
            variable="Inspiration1Heading"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'Inspiration2Heading')"
            [blockData]="block.variables?.Inspiration2Heading ?? ''"
            [placeholder]="heading2Placeholder"
            variable="Inspiration2Heading"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'Inspiration1CtaLink')"
            [blockData]="block.variables?.Inspiration1CtaLink ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="Inspiration1CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration1CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.Inspiration1CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration2CtaLink')"
            [blockData]="block.variables?.Inspiration2CtaLink ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="Inspiration2CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration2CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.Inspiration2CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration1CtaText')"
            [blockData]="block.variables?.Inspiration1CtaText ?? ''"
            [placeholder]="ctaText1Placeholder"
            variable="Inspiration1CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'Inspiration2CtaText')"
            [blockData]="block.variables?.Inspiration2CtaText ?? ''"
            [placeholder]="ctaText2Placeholder"
            variable="Inspiration2CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.Inspiration1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.Inspiration1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.Inspiration1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.Inspiration1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.Inspiration2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.Inspiration2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.Inspiration2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.Inspiration2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-center mt-2">
          <div
            class="col-6"
            [innerHTML]
            [innerHTML]="$safeNavigationMigration(block.variables?.Inspiration1Heading)"
          >
            >
          </div>
          <div
            class="col-6"
            [innerHTML]
            [innerHTML]="$safeNavigationMigration(block.variables?.Inspiration2Heading)"
          >
            >
          </div>
        </div>
        <div class="row text-center mt-2">
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.Inspiration1CtaLink)"
              target="_blank"
              *ngIf="block.variables?.Inspiration1CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.Inspiration1CtaText)"
            ></a>
          </div>
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.Inspiration2CtaLink)"
              target="_blank"
              *ngIf="block.variables?.Inspiration2CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.Inspiration2CtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
